import React from 'react';
import { Me } from '../model/UserModel';
import { useAuth } from './AuthContext';

export const UserContext: any = React.createContext({ user: Me });

function UserProvider(props: any) {
  const auth = useAuth();
  return <UserContext.Provider value={auth.data.user} {...props} />;
}

let useCurrentUser = (): Me => {
  const context = React.useContext<Me>(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }
  if (context) {
    return Object.assign(new Me(), context);
  } else {
    return context;
  }
};

export { UserProvider, useCurrentUser };
